import type { App } from 'vue'
import { VueRenderInspector } from '@platform-ui/vue-render-inspector'
import '@platform-ui/vue-render-inspector/dist/style.css' // Import styles for the panel
import { VueCookieNext } from 'vue-cookie-next'
import firebase from 'firebase/compat/app'




const isRestrictedEnv = (config: { mode?: string }): boolean => {
  return config.mode === 'production' || process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'interop'
}

const isAutomationTestsRun = (): boolean => {
  try {
    const automationTestsRun = VueCookieNext.getCookie('automation_tests_run')
    if (automationTestsRun === 'true' || automationTestsRun === true) {
      return true
    }
  } catch (error) {
    console.error('Error checking automation_tests_run cookie:', error)
  }
  return false
}

/**
 * Initialize vue-render-inspector plugin
 * Only enabled when not on login page, not in production, and not during automation tests
 * This prevents DataCloneError when trying to clone Vue reactive objects with Symbols
 */
export function initializeVueRenderInspector(app: App, config: { mode?: string }): void {
  // Only enable vue-render-inspector if not on login page and not in production
  // This prevents DataCloneError when trying to clone Vue reactive objects with Symbols
  // Hide vue-render-inspector panel by default - it should only open when clicking the TopBar button
  // Hide floating button since we use the TopBar button to toggle the inspector
  if (!isRestrictedEnv(config) && !isAutomationTestsRun()) {
    app.use(VueRenderInspector, {
      enabled: true,
      panelOpenByDefault: false,
      console: false,
      showFloatingButton: false,
      firestore: {
        firebase, // required: compat instance
        enabled: false,
        whitelist: { opportunities: ['status', 'pipeline_id'] }, // optional field allowlist for writes
        console: false, // optional: log queries/listeners to console
        slowQueryThresholdMs: 1500,
        onSlowQuery: entry => console.info('Slow Firestore operation', entry),
      },
      
    })
  }
}
